import user from './user'
import products from './products'
import { isLocalStorageAvailable } from '../storage'

/** Create a persistedStore if localstorage allowed, otherwise a regular store */
function persistedStore(name, value) {
    if (isLocalStorageAvailable()) {
        window.Alpine.persistedStore(name, value)
    } else {
        window.Alpine.store(name, value)
    }
}

document.addEventListener('alpine:init', () => {
    persistedStore('purchaseHistory', {})
    persistedStore('user', user)
    window.Alpine.store('products', products)

    window.Alpine.store('general', {
        showOverlay: false,
        showGeoModal: false,
        showBugModal: false,
        showInvalidShippingModal: false,
        showSpecModal: false,
        showQuoteModal: false,
        showCookieOptionModal: false,
        showDeliveryRatesModal: false,
        showGetQuote: false,
        invalidShippingModalType: null,
    })

    persistedStore('cart', {
        productCount: 0,
    })

    if (!window.Alpine.store('currency')) {
        persistedStore('currency', window.accuvars.currency)
    }

    if (!window.Alpine.store('settings')) {
        persistedStore('settings', {
            include_tax: false,
        })
    }

    if (!window.Alpine.store('address_selector')) {
        persistedStore('address_selector', {
            local_charges_may_apply: false,
            selected_delivery_country_name: '',
        })
    }

    // if not logged in, check the api to double check
    if (!window.Alpine.store('user').isLoggedIn) {
        window.Alpine.store('user').load()
    }

    if (!window.Alpine.store('cookies')) {
        persistedStore('cookies', {
            consent: false,
            accept() {
                this.consent = true
            },
        })
    }

    if (!window.Alpine.store('banner')) {
        persistedStore('banner', {
            closed: false,
        })
    }

    if (!window.Alpine.store('search')) {
        persistedStore('search', {
            history: [],
        })
    }

    if (!window.Alpine.store('gclid')) {
        persistedStore('gclid', {
            gclid: null,
            utl: null,
        })
    }

    window.Alpine.store('pricing', {
        quantityChanged: false,
    })
})
